import { action } from 'satcheljs';

export const onSavingChanged = action('onSavingChanged', (saving: boolean) => ({ saving }));
